var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.error
    ? _c(
        "div",
        { ref: "dashboard", staticClass: "dashboard-root" },
        [
          _c(
            "header",
            {
              style: { padding: "0 " + _vm.gutter },
              attrs: { id: "dashboard-header" }
            },
            [
              _c("h1", { staticClass: "mb-0" }, [
                _vm._v(
                  _vm._s(_vm.$l10n.__("Bonjour %(user)s", { user: _vm.user }))
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-item-right" },
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.dashboardManagementLabel,
                      type: "primary",
                      "data-bot": "dashboard-manage"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.togglePanelSettings($event)
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                { staticClass: "prelative" },
                [
                  _c(
                    "grid-layout",
                    {
                      ref: "grid",
                      attrs: {
                        layout: _vm.layout,
                        "col-num": _vm.col,
                        "row-height": 160,
                        "is-draggable": true,
                        responsive: true,
                        margin: [_vm.gutter, _vm.gutter],
                        breakpoints: _vm.breakpoints,
                        cols: _vm.cols
                      },
                      on: {
                        "layout-updated": _vm.layoutUpdated,
                        "update:layout": _vm.layoutUpdated
                      }
                    },
                    _vm._l(_vm.layout, function(item) {
                      return _c(
                        "grid-item",
                        {
                          key: item.type,
                          attrs: {
                            "drag-allow-from": ".card-header",
                            x: item.x,
                            y: item.y,
                            w: item.w,
                            h: item.h,
                            i: item.i,
                            "is-resizable": item.resizable,
                            "min-w": item.minw,
                            "min-h": item.minh,
                            "max-w": item.maxw,
                            "max-h": item.maxh
                          },
                          on: {
                            resized: _vm.resizeEvent,
                            moved: _vm.layoutUpdated
                          }
                        },
                        [
                          _vm.getCard(item.type)
                            ? [
                                _c(_vm.getTypeCard(item.type) + "-card", {
                                  key: item.type,
                                  ref: item.type,
                                  refInFor: true,
                                  tag: "component",
                                  attrs: {
                                    settings: _vm.getCard(item.type).settings,
                                    "custom-settings": _vm.getCard(item.type)
                                      .customSettings,
                                    name: _vm.getCard(item.type).name,
                                    type: _vm.getTypeCard(item.type),
                                    loading: item.loading,
                                    data: _vm.getCard(item.type).content,
                                    error: _vm.getCard(item.type).error,
                                    timeout: _vm.timeout
                                  },
                                  on: {
                                    "hide-card": _vm.removeItem,
                                    fetched: _vm.cardFetchedEvent,
                                    "set-monitored-report-cards":
                                      _vm.setMonitoredReportCards
                                  }
                                })
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.openPanelSettings
                    ? _c("cards-settings-panel", {
                        ref: "cardSettingsPanel",
                        attrs: {
                          items: _vm.cardsForSettings,
                          "default-opened-tab": _vm.defaultOpenedTab,
                          max: _vm.max,
                          min: _vm.min,
                          "default-report-card-limit": _vm.reportCardLimit
                        },
                        on: {
                          close: _vm.togglePanelSettings,
                          add: _vm.addItem,
                          removed: _vm.removeItem,
                          save: _vm.applyButton
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _c("preloader", { attrs: { background: false, display: true } }),
          _vm._v(" "),
          _c("portal-target", {
            attrs: { name: "dashboardSettingsForm", multiple: true }
          }),
          _vm._v(" "),
          _vm.showRecapDialog
            ? _c("RecapDialog", {
                attrs: { visible: _vm.isRecapDialogVisible },
                on: {
                  "update:visible": function($event) {
                    _vm.isRecapDialogVisible = $event
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }